module.exports = __webpack_public_path__ + "img/ury.79b02850.svg";